import i18n from 'i18next'
import translationTR from './translation/TR.json'
import translationEN from './translation/EN.json'
import { initReactI18next } from 'react-i18next'

// the translations
const resources = {
  en: {
    translation: translationEN,
  },
  tr: {
    translation: translationTR,
  },
}

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    debug: process.env.NODE_ENV !== 'production',
    resources,
    load: 'languageOnly',
    fallbackLng: {
      'tr-TR': ['tr'],
      default: ['tr'],
    },
    lng: localStorage.getItem('lang') || 'tr',
    detection: {
      order: ['navigator'],
      caches: [],
    },
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  })

export default i18n
